import requestService from './requestService';

const endpoints = {
  feedback: '/chatroom/feedback/',
  feedbackV2: 'chatroom/feedback/v2',
  feedbacks: '/chatroom/feedbacks',
};

export const getFeedbacks = async() => {
  try {
    return requestService.get(`${endpoints.feedbacks}`, null, {
      apiType: 'platform-v2',
    });
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postChatFeedback = async(feedback, roomId) => {
  try {
    return requestService.postWithJson(
      `${endpoints.feedback}${roomId}`, 
      null, 
      feedback, 
      { apiType: 'platform-v2' }
      );
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postChatFeedbackV2 = async(feedback) => {
  try {
    return requestService.postWithJson(
      `${endpoints.feedbackV2}`, 
      null, 
      feedback, 
      { apiType: 'platform' }
      );
  } catch (e) {
    console.error(e);
    throw e;
  }
};